module.exports = __webpack_public_path__ + "img/wolf_320.0f57b5ed.png";